export default __webpack_public_path__ + "static/media/import.b5fde567.svg";